module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ggIwA"))).then(() => parcelRequire('d0iPb'));